import React, { useMemo, useCallback } from 'react';
import { formControl } from '@core/utils/form';
import { FormCheckbox } from '@core/components/form';
import { CompactChecklistResponse, ChecklistResponse, ChecklistId } from '@business/entities/checklist/ChecklistResponse';
import { Badge } from 'reactstrap';
import { ChecklistService } from '@business/services/checklist_service';
import { openTodoChecklistOverlay } from '../../Components/TodoChecklistOverlay';
import { useHistory } from '@core/router';
import { toMoment } from '@core/utils/time';
import { FormUserAvatar } from '@core/components/form/FormUserAvatar';
import { UserResponse } from '@business/entities/account';
import { TeamResponse } from '@business/entities/team';
import { ChecklistRecurring } from '@business/entities/checklist';

export interface ChecklistItemProps {
  checklist: CompactChecklistResponse | ChecklistResponse;
  isCompleted?: boolean;
  users: UserResponse[];
  teams: TeamResponse[];
  onAssign(type: string, checklistId: ChecklistId, assignees: string[]): void;
  parentSectionId: string;
}

export const ChecklistItem = (props: ChecklistItemProps) => {
  const { checklist, isCompleted, users, teams, onAssign, parentSectionId } = props;

  const control = useMemo(
    () =>
      formControl<boolean>({
        initialValue: checklist.isCompleted,
      }),
    [checklist],
  );

  const history = useHistory();

  const onClick = useCallback(() => {
    history.push(`/todos/${isCompleted ? 'completed' : 'pending'}/checklist/${checklist.id}`);
    // openTodoChecklistOverlay({ checklistId: checklist.id, title: checklist.title });
  }, [checklist.id, history, isCompleted]);

  const hasDueDate = useMemo(() => checklist.dueDate !== 0, [checklist.dueDate]);
  const avatarControl = formControl<string[]>({
    initialValue: checklist.assignees,
  });

  return (
    <>
      <div className="task-item noselect task-tr-div">
        <div className="task-td-div task-w-move"></div>
        <div className="row task-td-div task-w-name justify-content-between" style={{ width: '100%' }}>
          <div className="col col-lg-5 d-flex align-items-center">
            {/* <FormCheckbox noPadding control={control} disabled /> */}
            <div className="text-truncate" style={{ maxWidth: 300 }}>
              <a className="d-flex flex-column" onClick={onClick}>
                <span className="text-dark">{checklist.title}</span>
              </a>
            </div>
            {hasDueDate && (
              <span className={`ml-3 font-size-11 text-muted text-${checklist.dueDatePassed ? 'danger' : 'primary'}`}>
                Complete by {toMoment(checklist.dueDate).format('MM/DD')}
              </span>
            )}
          </div>

          <div className="col col-lg-2 d-flex align-items-center">
            <div style={{ fontWeight: 400, textAlign: 'left' }}>
              <FormUserAvatar
                tooltipContainer={parentSectionId}
                control={avatarControl}
                type="both"
                users={users}
                teams={teams}
                onChange={assignee => onAssign('checklist', checklist.id, assignee || [])}
              />
            </div>
          </div>
          <div className="col col-lg-3 d-flex align-items-center">
            {checklist.recurring != ChecklistRecurring.oneTime && <i className="fas fa-retweet mr-1" />}
            <div className="text-muted font-size-12">{ChecklistService.getRecurringInfo(checklist)}</div>
          </div>
          <div className="col col-auto d-flex align-items-center">
            <Badge className={`${ChecklistService.getStatusClass(checklist.status)} font-size-12 p-1`}>
              {ChecklistService.getStatusTitle(checklist.status)}
            </Badge>
          </div>
        </div>
      </div>
    </>
  );
};
